import type { IconData } from '@stacksjs/iconify-core'

export const basicUiView: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 14.5c5.5 0 8-6.5 8-6.5s-2.5-6.5-8-6.5S0 8 0 8s2.5 6.5 8 6.5M8 10a2 2 0 1 0 0-4a2 2 0 0 0 0 4\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiView
